// extracted by mini-css-extract-plugin
export default {"attachButton":"Attach_attachButton__o5M4P"};